import React, { useEffect, useState } from "react";
import { Button, Empty, Space, Table, Typography, message as messager } from "antd";
import { ColumnsType } from "antd/es/table";
import { useAccoutContext } from "../provider";

import { GetAgreement } from "../../../../../../services/data/DataService";
import { GetAuditList, GetAuditPass, GetAuditRollback } from "../../../../../../services/dct/DctService";

import ValueIf from "../value-if";
import RejectModal from "../reject-modal";

import clsName from "./index.module.scss";
import RemarkModal from "../remark-modal";
import SubjectModal from "../../../../visit/components/SubjectModal";
import ModalLabor from '../../../../../../components/project/detail/setting/modalLabor/modalLabor';
import RevokeModal from "../revoke-modal";
import { readRoleCode, readUserCode } from "../../../../../../utils/storage";

const pageSize = 20;

export interface DataRecord {
  auditState: number
  auditStateName: string
  centerCode: string
  centerName: string
  handleUser: string
  handleTime: string
  isHaveAgreement: boolean
  name: string
  projectCode: string
  projectName: string
  rejectReasons: string
  remark: string
  repeatRemark: string
  subjectCode: string
  subjectId: string
  tenantCode: string
  tenantName: string
  updateTime: string
  uploadTime: string

  userCode: string
  userName: string
}

interface DataTableProps {}
const DataTable: React.FC<DataTableProps> = () => {

  const { queryParams } = useAccoutContext();

  const [hasAuth, setHasAuth] = useState(false);

  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const [dataSource, setDataSource] = useState<DataRecord[]>([]);

  // 拒绝弹窗
  const [rejectModalVisble, setRejectModalVisble] = useState(false)

  // 部分撤回弹窗
  const [revokeModalVisble, setRevokeModalVisble] = useState(false)

  // 编辑备注弹窗
  const [remarkModalVisble, setRemarkModalVisble] = useState(false)

  // CRF弹窗
  const [formModalVisible, setFormModalVisible] = useState(false)

  // 协议弹窗
  const [laborModalVisible, setLaborModalVisible] = useState(false)
  const [laborAgreementContent, setLaborAgreementContent] = useState('')

  //
  const [selectedKeys, setSelectedKeys] = useState<string[]>([])

  // 行按钮选择
  const [selectedTask, setSelectedTask] = useState<DataRecord>()

  const columns: ColumnsType<DataRecord> = [
    {
      title: "任务编号",
      width: 160,
      dataIndex: "subjectCode",
    },
    {
      title: "租户名称",
      width: 160,
      dataIndex: "tenantName",
    },
    {
      title: "姓名",
      width: 120,
      dataIndex: "name",
    },
    {
      title: "所属项目",
      width: 240,
      dataIndex: "projectName",
    },
    {
      title: "所属中心",
      width: 200,
      dataIndex: "centerName",
    },
    {
      title: "上传人",
      width: 100,
      render: (_, {userName, userCode}) => {
        return (
          <div className={clsName.render}>
            <div className={clsName.title}>{userName}</div>
            <div className={clsName.subtitle}>{userCode}</div>
          </div>
        );
      },
    },
    {
      title: "上传时间",
      width: 180,
      render: (_, { uploadTime }) => {
        return (
          <div className={clsName.render}>
            <div className={clsName.title}>
              {uploadTime ? uploadTime.replace("T", " ") : ""}
            </div>
          </div>
        );
      },
    },
    {
      title: "审核状态",
      width: 120,
      dataIndex: "auditState",
      render: (value) => ["", "待审核", "通过", "未通过"][value] || '未通过',
    },
    {
      title: "审核人",
      width: 120,
      dataIndex: "handleUser",
      render: (_, { handleUser }) => {
        return (
          <div className={clsName.render}>
            <div className={clsName.title}>{handleUser}</div>
          </div>
        );
      },
    },
    {
      title: "审核时间",
      width: 180,
      render: (_, { handleTime }) => {
        return (
          <div className={clsName.render}>
            <div className={clsName.title}>
              {handleTime ? handleTime.replace("T", " ") : ""}
            </div>
          </div>
        );
      },
    },
    {
      title: "更新时间",
      width: 180,
      render: (_, { updateTime }) => {
        return (
          <div className={clsName.render}>
            <div className={clsName.title}>
              {updateTime ? updateTime.replace("T", " ") : ""}
            </div>
          </div>
        );
      },
    },
    {
      title: "拒绝原因",
      width: 200,
      render: (_, {rejectReasons, repeatRemark }) => {
        return (
          <div className={clsName.render}>
            <div className={clsName.title}>{rejectReasons}</div>
            <div className={clsName.subtitle}>{repeatRemark}</div>
          </div>
        );
      },
    },
    {
      title: "备注",
      width: 200,
      dataIndex: "remark",
    },
    {
      title: "操作",
      width: hasAuth ? 450 : 250,
      fixed: "right",
      align: "center",
      render: (_, record) => (
        <div onClick={(e) => e.stopPropagation()}>
          <Button type="link" onClick={() => viewForm(record)}>查看</Button>
          {
            !['CRCKHCM', 'KHCESHI'].includes(readUserCode() || '') && (
            <>
              {
                record.isHaveAgreement && (
                  <Button type="link" onClick={() => viewAgreement(record)}>查看协议</Button>
                )
              }
              {hasAuth && (
              <>
                <Button type="link" onClick={() => viewRemark(record)}>编辑备注</Button>
                <Button
                  type="link"
                  disabled={record.auditState == 2}
                  onClick={() => handleAgree([record.subjectCode])}
                >
                  <ValueIf value={record.auditState == 1 || record.auditState == 3} otherwise="已通过">通过</ValueIf>
                </Button>
                <Button
                  danger
                  type="link"
                  disabled={record.auditState == 3 || record.auditState == 2}
                  onClick={() => viewReject(record)}
                >
                  <ValueIf value={record.auditState == 1 || record.auditState == 2} otherwise="已拒绝">拒绝</ValueIf>
                </Button>
                {
                  (record.auditState == 3 || record.auditState == 2) && (
                    <>
                      <Button danger type="link" onClick={() => handleRevoke(record)}>撤销</Button>
                      <Button danger type="link" onClick={() => viewRevoke(record)}>部分撤销</Button>
                    </>
                  )
                }
              </>
              )}
            </>
            )
          }
        </div>
      ),
    },
  ];

  const fetchDataSource = async (page = 1) => {
    setLoading(true)
    const { data } = await GetAuditList({
      ...queryParams,
      page,
      pageSize: 20,
    });

    setLoading(false)
    setPage(page)
    setTotal(data.total);
    setDataSource(data.rows);
  }

  const handleAgree = async(subjectCodes: string[]) => {
    const { code } = await GetAuditPass({ subjectCodes })

    if (code === 0) {
      fetchDataSource()
      setSelectedKeys([])
      messager.success('通过成功')
    }
  };

  const viewAgreement = async ({ subjectCode }: DataRecord) => {
    const { code, data } = await GetAgreement({ subjectCode })

    if (code === 0) {
      setLaborModalVisible(true)
      setLaborAgreementContent(data)
    }
  };

  const viewForm = (record: DataRecord) => {
    setSelectedTask(record)
    setFormModalVisible(true)
  };

  // 编辑备注
  const viewRemark = (record: DataRecord) => {
    setSelectedTask(record)
    setRemarkModalVisble(true)
  };

  // 拒绝弹窗
  const viewReject = (record?: DataRecord) => {
    setSelectedTask(record)
    setRejectModalVisble(true)
  };

  // 部分撤回弹窗
  const viewRevoke = (record?: DataRecord) => {
    setSelectedTask(record)
    setRevokeModalVisble(true)
  };

  // 撤销
  const handleRevoke = async ({ subjectCode }: DataRecord) => {
    const { code, message } = await GetAuditRollback({
      subjectCode,
      formIdList: [],
      cancelType: 1
    })

    if (code === 0) {
      messager.success(message)
      fetchDataSource()
    }
  };

  useEffect(()=> {
    fetchDataSource()
  }, [queryParams])

  useEffect(()=> {
    setHasAuth(!["DC_DM", "DC_AM"].includes(readRoleCode()));
  }, [])

  return (
    <div className={clsName.tableWrapper}>
      <div className={clsName.toolbar}>
        <div className={clsName.west}>
          {
            !['CRCKHCM', 'KHCESHI'].includes(readUserCode() || '') && (
              <>
                <Button onClick={()=> handleAgree(selectedKeys)} disabled={selectedKeys.length === 0} type="primary">全部通过</Button>
                <Button onClick={()=> viewReject()} disabled={selectedKeys.length === 0} danger>全部拒绝</Button>
              </>
            )
          }
          {
            selectedKeys.length > 0 && (
              <Space align="center">
                <Typography.Text>已选择{ selectedKeys.length }个</Typography.Text>
              </Space>
            )
          }
        </div>
      </div>
      <Table
        loading={loading}
        size="middle"
        rowKey="subjectCode"
        rowSelection={{
          selectedRowKeys: selectedKeys,
          onChange: (keys: React.Key[]) => {
            setSelectedKeys(keys as string[])
          },
        }}
        scroll={{ y: window.innerHeight - 375 }}
        columns={columns}
        dataSource={dataSource}
        locale={{ emptyText: <Empty description="暂无数据" /> }}
        pagination={{
          onChange: fetchDataSource,
          total: total,
          current: page,
          pageSize: pageSize,
          showSizeChanger: false,
          showQuickJumper: false,
          showTotal: (total) => `共${total}条，每页${pageSize}条`,
          position: ["bottomRight"],
        }}
      />

      {
        revokeModalVisble && selectedTask && (
          <RevokeModal
            subjectCode={selectedTask?.subjectCode}
            onClose={(reload)=> {
              setRevokeModalVisble(false)
              if (reload) {
                setSelectedKeys([])
                fetchDataSource()
              }
            }}
          />
        )
      }

      {
        rejectModalVisble && (
          <RejectModal
            takeSubjectCodes={()=> {
              if (selectedTask) {
                return [selectedTask.subjectCode]
              }
              return selectedKeys
            }}
            onClose={(reload)=> {
              setRejectModalVisble(false)
              if (reload) {
                setSelectedKeys([])
                fetchDataSource()
              }
            }}
          />
        )
      }

      {
        remarkModalVisble && selectedTask && (
          <RemarkModal
            content={selectedTask.remark}
            subjectId={selectedTask.subjectId}
            onClose={(reload)=> {
              setRemarkModalVisble(false)
              if (reload) {
                fetchDataSource()
              }
            }}
          />
        )
      }

      {
        formModalVisible && selectedTask && (
          <SubjectModal
            usingQuestion
            subjectCode={selectedTask.subjectCode}
            onClose={()=> setFormModalVisible(false)}
          />
        )
      }

      {
        laborModalVisible && (
          <ModalLabor
            visible={true}
            closeModal={()=> setLaborModalVisible(false)}
            content={laborAgreementContent}
            readOnly={true}
          />
        )
      }
    </div>
  );
};

export default DataTable;
